import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { ensureIOSocketConnected, emitSocketRoomChange, IOSOCKETCLIENT } from "../../linksocket/linksocket";
import { MAKE_SOCKET_CHANNEL, SOCKET_CHANNELS } from "../../constants/constants";
import { pushNotification } from "../../redux/notificationSlice";
import { notificationFromSocketEvent } from "./notificationMessages";

const USER_ROOM_EVENTS = [
  SOCKET_CHANNELS.MAIL,
  SOCKET_CHANNELS.PREINTAKE,
  SOCKET_CHANNELS.EETDAGBOEK,
  SOCKET_CHANNELS.DOCUMENTEN,
  SOCKET_CHANNELS.VOORUITGANG,
  SOCKET_CHANNELS.COMMENTS,
  SOCKET_CHANNELS.VRAGENLIJSTEN,
  SOCKET_CHANNELS.KLACHTENFORMULIER,
  SOCKET_CHANNELS.CHAT,
  SOCKET_CHANNELS.SUPPORT,
  SOCKET_CHANNELS.PAYMENTS,
];

/**
 * Joins per-user Socket.IO rooms (same channel names as server `io.to(...)`)
 * and dispatches in-app notifications. Does not use `setIOSocketListeners`
 * so it never calls `off(event)` for the whole event name (which would break
 * other listeners like the mailbox thread listener).
 */
const SocketNotificationBridge = ({ userId }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!userId) return undefined;
    if (!ensureIOSocketConnected()) return undefined;

    const cleanupFns = [];

    USER_ROOM_EVENTS.forEach((eventName) => {
      const room = MAKE_SOCKET_CHANNEL(userId, eventName);
      const handler = (payload) => {
        const n = notificationFromSocketEvent(eventName, payload, userId);
        dispatch(pushNotification(n));
      };

      emitSocketRoomChange("join", room);
      IOSOCKETCLIENT.on(eventName, handler);

      cleanupFns.push(() => {
        IOSOCKETCLIENT.off(eventName, handler);
        emitSocketRoomChange("leave", room);
      });
    });

    return () => {
      cleanupFns.forEach((fn) => fn());
    };
  }, [userId, dispatch]);

  return null;
};

export default SocketNotificationBridge;
